// Um campo customizado sem `condition_field` sempre aparece (comportamento
// padrão). Com `condition_field` setado, só aparece se o valor ATUAL do
// campo-gatilho (procurado em `allFields` pelo id, lido em `values` pelo
// `name`) bater com `condition_value`.
export const isFieldVisible = (field, allFields, values) => {
    if (!field.condition_field) return true;

    const triggerField = allFields.find((f) => f.id === field.condition_field);
    if (!triggerField) return true;

    const currentValue = values?.[triggerField.name];
    return String(currentValue ?? '').trim() === String(field.condition_value ?? '').trim();
};
